import logo from "./logo/logo.svg";
import logo_white from "./logo/logo_white.svg";
import coinsVector from "./illustrations/coins.svg";
import teamVector from "./illustrations/team.svg";
import profileVector from "./illustrations/profile.svg";
import savingsVector from "./illustrations/savings.svg";
import { ReactComponent as cashDollarVector } from "./illustrations/cash-dollar.svg";
import { ReactComponent as handCoinVector } from "./illustrations/hand-coin.svg";
import { ReactComponent as goldCoins } from "./illustrations/gold-coins.svg";
import { ReactComponent as profile } from "./icons/profile.svg";
import { ReactComponent as home } from "./icons/home.svg";
import { ReactComponent as wallet } from "./icons/wallet.svg";
import { ReactComponent as caseIcon } from "./icons/case.svg";
import { ReactComponent as card } from "./icons/card.svg";
import { ReactComponent as database } from "./icons/database.svg";
import { ReactComponent as group } from "./icons/profile-user.svg";
import { ReactComponent as bell } from "./icons/bell.svg";

export const Logo = logo;
export const LogoWhite = logo_white;

// ILLUSTRATION
export const Coins = coinsVector;
export const Team = teamVector;
export const Profile = profileVector;
export const Savings = savingsVector;
export const CashDollar = cashDollarVector;
export const HandCoin = handCoinVector;
export const GoldCoins = goldCoins;

// ICONS
export const HomeIcon = home;
export const ProfileIcon = profile;
export const WalletIcon = wallet;
export const CaseIcon = caseIcon;
export const CardIcon = card;
export const GroupIcon = group;
export const DatabaseIcon = database;
export const BellIcon = bell;
